<template>
  <div>
    <h3>
      {{ titleobj.projectLeaderName }}负责的项目【{{ titleobj.name }}】已开始{{
        titleobj.useTime
      }}天，当前进度 “{{ titleobj.stateName }}”
    </h3>
    <div class="tab-list">
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div v-for="(v, k) in menus"   style="display:inline-block;" :key="k">
            <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div class="addactivity">
      <Button type="info" ghost @click="this.toAdd">新增任务</Button>
    </div>
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <Table
        :columns="tableCols"
        :data="data2"
        :table="table"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
      >
      </Table>
    </Row>
  </div>
</template>

<script>
let customerId = window.localStorage.getItem("customerId");
export default {
  data() {
    return {
      menus: [
        {
          label: "项目全景",
          name: "panorama",
        },
        {
          label: " 跟进记录",
          name: "schedule_Info",
        },
        {
          label: "任务",
          name: "task_Info",
        },
        {
          label: Number(customerId) == 0 ? "客户" : "供应商",
          name: "supplier_List",
        },
       {
          label: "合同",
          name: "contract_Info",
        },
        {
          label: "发票/支付",
          name: "invoice_Info",
        },
      ],
      menu_name: "",
      data2: [],
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "任务内容",
          key: "applyContent",
          minWidth: 300,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.applyContent;
            let tempDescr;
            let teColor;
            if (text != null) {
              if (text.indexOf("]") != -1) {
                let arr = text.split("]");
                let tempDate = parseInt(arr[0]);
                let tempContext = text.replace(arr[0] + "]", "");

                let tempH = Math.floor(tempDate / 60);
                let day = Math.floor(tempH / 24);
                let hour = tempH % 24;
                let min = tempDate % 60;
                tempDescr = "[" + day + "天" + hour + "时" + min + "分]" + tempContext;
                if (row.state == 1) {
                  teColor = "red";
                }
              } else {
                tempDescr = "[" + 0 + "h" + 0 + "m]" + text;
              }
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: teColor,
                  },
                  domProps: {
                    title: tempDescr,
                  },
                },
                tempDescr
              ),
            ]);
          },
        },
        {
          title: "责任人",
          key: "finishUser",
          width: 120,
          align: "center",
          tooltip: "true",
        },
        /*   {
          title: "发起科室",
          key: "applyDeskName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "发起时间",
          width: 150,
          align: "center",
          key: "applyTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.applyTime.slice(0, 16);
            return <span> {text} </span>;
          },
        },
        {
          title: "紧急程度",
          key: "emergencyDegree",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.emergencyDegree;
            if (text == 1) {
              return <span>一般</span>;
            } else if (text == 2) {
              return <span>较重要</span>;
            } else if (text == 3) {
              return <span>重要</span>;
            } else if (text == 4) {
              return <span>特别重要</span>;
            }
          },
        }, */
        {
          title: "状态",
          key: "state",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state;
            if (text == 1) {
              return <span>未完成</span>;
            } else if (text == 2) {
              return <span>已完成</span>;
            }
          },
        },
        /* {
          title: "相关文件",
          key: "applyFileUrl",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            if (row.applyFileUrl !== null) {
              const text = config.IMAGE_HOST + row.applyFileUrl;
              return (
                <a style="margin-left:20px" href={text} target="_blank">
                  <svg
                    t="1686795127586"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7800"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                      fill="#CCA352"
                      p-id="7801"
                    ></path>
                    <path
                      d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                      fill="#FFFFFF"
                      p-id="7802"
                    ></path>
                    <path
                      d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                      fill="#FFCC66"
                      p-id="7803"
                    ></path>
                  </svg>
                </a>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "处理内容",
          key: "finishContent",
          minWidth: 130,
          align: "left",
        },
        {
          title: "完成时间",
          width: 150,
          align: "center",
          key: "finishTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.finishTime != null ? row.finishTime.slice(0, 16) : "";
            return <span> {text} </span>;
          },
        },
        {
          title: "结果文件",
          key: "resultFileUrl",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            if (row.resultFileUrl != null) {
              const text = config.IMAGE_HOST + row.resultFileUrl;
              return (
                <a style="margin-left:10px" href={text} target="_blank">
                  <svg
                    t="1686795127586"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="7800"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                      fill="#CCA352"
                      p-id="7801"
                    ></path>
                    <path
                      d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                      fill="#FFFFFF"
                      p-id="7802"
                    ></path>
                    <path
                      d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                      fill="#FFCC66"
                      p-id="7803"
                    ></path>
                  </svg>
                </a>
              );
            } else {
              return;
            }
          },
        }, */
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          render: (vm, param) => {
            const row = param.row;
            return (
              <div>
                <Button
                  size="small"
                  onClick={() => this.toEdit(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                    display: row.state === 2 ? "none" : "",
                  }}
                >
                  编辑
                </Button>
                <Button
                  size="small"
                  onClick={() => this.selectChange(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
                <Button
                  size="small"
                  onClick={() => this.delItem(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  删除
                </Button>
              </div>
            );
          },
        },
      ],
      projectId: window.localStorage.getItem("projectId"),
      titleobj: {},
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.initData(this.projectId);
    this.load(this.projectId);
  },
  methods: {
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/${id}`);
        try {
          if (res.code == 200) {
            this.titleobj = res.data;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    toAdd() {
      let projectId = window.localStorage.getItem("projectId");
      $utils.url.push({
        name: "add_task",
        query: { action: "add", projectId: projectId },
      });
    },
    async load(id) {
      let d = { projectId: id };
      let res = await $utils.api.load("/admin/system/task/list", d, "get");
      if (res.code == 200 && res.rows.length > 0) {
        this.data2 = res.rows;
      }
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    toEdit(row) {
      $utils.url.push({
        name: "add_task",
        query: {
          kv: row.id,

          action: "edit",
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(`/admin/system/task/del/${row.id}`, d, "DELETE");
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    },
    selectChange(row) {
      let kv = row.id;
      $utils.url.push({
        name: "Info_Task",
        query: { action: "view", kv: kv },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addactivity {
  margin-top: 10px;
}
</style>
